import { Injectable, inject, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { PractiseOverviewPageActions } from './practise.actions';
import {
  selectBookSelectModalVM,
  selectPractiseOverviewVM,
} from './practise-vm.selectors';
import {
  BookSelectModalVM,
  PractiseOverviewCard,
  PractiseOverviewVM,
  PractiseType,
} from '@lyceo/lyceo-pupil-app/practise/util-models';
import { selectPractiseOverviewLoaded } from './practise.selectors';

@Injectable({
  providedIn: 'root',
})
export class PractiseOverviewFacade {
  private readonly store: Store = inject(Store);

  public readonly practiseOverviewLoaded: Signal<boolean> =
    this.store.selectSignal(selectPractiseOverviewLoaded);
  public readonly practiseOverviewVM: Signal<PractiseOverviewVM> =
    this.store.selectSignal(selectPractiseOverviewVM);
  public readonly bookSelectModalVM: Signal<BookSelectModalVM> =
    this.store.selectSignal(selectBookSelectModalVM);

  public init(): void {
    this.store.dispatch(PractiseOverviewPageActions.init());
  }

  public segmentClicked(practiseType: PractiseType): void {
    this.store.dispatch(
      PractiseOverviewPageActions.segmentClicked({ practiseType }),
    );
  }

  public selectBookClicked(scopeId: string): void {
    this.store.dispatch(
      PractiseOverviewPageActions.selectBookClicked({ scopeId }),
    );
  }

  public cardClicked(card: PractiseOverviewCard): void {
    this.store.dispatch(PractiseOverviewPageActions.cardClicked({ card }));
  }
}
